import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Script = ({ src, strategy, ...props }) => <script src={src} {...props} />;
const Reviews = () => {
    return (_jsxs("section", { className: "w-full bg-white py-16 sm:py-20 lg:py-28", children: [_jsx("div", { className: "container mx-auto px-4 sm:px-6 lg:px-8", children: _jsx("div", { className: "elfsight-app-87f8c95a-ec3e-4c81-a0ee-8547d4ecd715", "data-elfsight-app-lazy": "" }) }), _jsx(Script, { src: "https://elfsightcdn.com/platform.js", strategy: "afterInteractive" })] }));
};
export default Reviews;
